import { ApiService } from '~/shared/api'
import { RequestService } from '~/services/RequestService'
import { AccountResumeModel } from '~/model/AccountResumes'
import { ResumeDictionaryItem } from '~/interfaces/Resumes'

interface AccountResumesResponse {
  data: AccountResumeModel
}

class AccountResumesService extends ApiService {
  constructor(requestService: RequestService) {
    super(requestService)
  }

  async getAccountResumes(): Promise<AccountResumeModel | null> {
    try {
      const response = await this.requestService.request<AccountResumesResponse>({
        url: '/api/v1/yavagro/resumes',
        _silent: true
      })
      return new AccountResumeModel(response.data.data)
    } catch (err) {
      console.warn(err) // eslint-disable-line no-console
      return null
    }
  }

  async downloadResumePdf(): Promise<Blob | null> {
    try {
      const response = await this.requestService.request<Blob>({
        url: '/api/v1/yavagro/profile-resume/pdf',
        responseType: 'blob'
      })
      return response.data
    } catch (err) {
      console.warn(err) // eslint-disable-line no-console
      return null
    }
  }

  async changeResumeStatus(resumeId: number, statusId: string): Promise<void> {
    await this.requestService.request({
      url: '/api/v1/yavagro/resumes/changeStatus',
      method: 'POST',
      data: { resume: { id: resumeId, status_id: statusId } }
    })
  }

  public async getDictionaryData(dictionary: string, search?: string): Promise<ResumeDictionaryItem[]> {
    const res = await this.requestService.request<{ result: ResumeDictionaryItem[] }>({
      url: '/api/v1/yavagro/resumes/get-dictionary-data',
      params: {
        dictionary,
        ...(search ? { search } : {})
      }
    })
    return res.data.result ?? []
  }
}

export default AccountResumesService
